import { createAction, props } from '@ngrx/store';

import { SecurityInfo } from 'SecuritiesApp/ts/interfaces/security-info.interface';

export const addSecuritiesInfo = createAction(
    '[Securities] Add Securities Info',
    props<{ securitiesInfo: Omit<SecurityInfo, 'security_id' | 'detailed_security_type'>[] }>()
);
